const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.ServiceTitan.DesignSystem['application-83abc821'];